export const CANCELED_RESPONSE_MESSAGE = "Response canceled.";

export function markLatestResponseCanceled(messages = []) {
  const lastMessage = messages[messages.length - 1];
  if (!lastMessage || lastMessage.type !== "assistant") {
    return messages;
  }

  return [
    ...messages.slice(0, -1),
    {
      ...lastMessage,
      action: "response",
      message: lastMessage.message || CANCELED_RESPONSE_MESSAGE,
    },
  ];
}
